import { useState } from "react";
import AllCallsHIstory from "./AllCallsHIstory";
import MissedCallHIstory from "./MissedCallHIstory";
import TextTranslate from "../../../utils/TextTranslate";

const TABS = [
  { id: 0, label: "All Calls" },
  { id: 1, label: "Missed Call" },
] as const;

export default function CallHistoryTabs() {
  const [selectedTab, setSelectedTab] = useState(0);

  return (
    <div className="flex h-full min-h-0 w-full flex-col">
      <div className="shrink-0 px-4 py-3">
        <div
          className="grid grid-cols-2 rounded-[9px] bg-black/[0.06] p-[3px] dark:bg-white/[0.1]"
          role="tablist"
        >
          {TABS.map((tab) => {
            const active = selectedTab === tab.id;
            return (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => setSelectedTab(tab.id)}
                className={`rounded-[7px] py-1.5 text-center text-[13px] font-semibold transition ${
                  active
                    ? "bg-primary text-darkText shadow-sm"
                    : "text-darkText/55"
                }`}
              >
                <TextTranslate text={tab.label} />
              </button>
            );
          })}
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-y-auto px-3 pb-8">
        {selectedTab === 0 ? <AllCallsHIstory /> : <MissedCallHIstory />}
      </div>
    </div>
  );
}
